import { newrelic } from "@jti/fe-clients";
import { getConfig } from "@jti/fe-common";

import { createLegacyApiWarningAttributes, getIsEvo, getUser } from "../../utils";

import type { DeviceApiContract } from "./DeviceApi.types";
import { DeviceApiEvo } from "./DeviceApiEvo";
import { DeviceApiLegacy } from "./DeviceApiLegacy";

export class DeviceApi {
  static init(jwtToken: string): DeviceApiContract {
    const config = getConfig();
    const user = getUser();
    if (config.USE_EVO_ONLY) {
      return new DeviceApiEvo(config.EVO_DOMAIN, config.EVO_TENANT, config["X-RECAPTCHA-ID"], user.ciam_token);
    }
    if (getIsEvo(config.DES_DEVICE_SERVICE_URL)) {
      return new DeviceApiEvo(
        config.DES_DEVICE_SERVICE_URL,
        config.DIS_DES_AK_TENANT_TOKEN,
        config["X-RECAPTCHA-ID"],
        user.ciam_token
      );
    }
    newrelic.sendWarning(
      "DeviceApiLegacy initialized - legacy API client in use",
      createLegacyApiWarningAttributes(config, config.DES_DEVICE_SERVICE_URL)
    );

    return new DeviceApiLegacy(
      config.DES_DEVICE_SERVICE_URL,
      config.DIS_DES_AK_TENANT_TOKEN,
      user.ciam_token,
      jwtToken
    );
  }
}
